<template lang="html">
<div class="v-scope-home-modulo-encuestas">
<div class="encuestas-view" id="encuestas" v-if="data.length > 0">

    <h2>{{ $t('encuestas.titulo') }}</h2>

    <section class="listado-encuestas container row-between pl-0">
      <template v-for="(encuesta, key) in data">
        <encuesta-el :prop="encuesta" :key="key"></encuesta-el>
      </template>
    </section>

    <!-- <p v-else class="no-encuestas">{{$t('encuestas.zero')}}</p> -->


  </div>
</div>
</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import encuestaEl from '@/components/parts/encuesta-el';

export default {
  name: 'modulo-encuestas',
  mounted() {

    if (!!this.userType) {
      this.requestEncuestas(this.userType);
    }

    if (this.$route.hash == "#encuestas") {
      let top = $("#encuestas").offset().top;

      $("html, body").animate({ scrollTop: top }, 1000);

    }


  },
  computed: {
    ...mapGetters({
      data: 'getEncuestas',
      colors: 'basicColors',
      style: 'getStyles',
      userType: 'getUserType'
    })
  },
  components: {
    'encuesta-el': encuestaEl
  },
  methods: {
    ...mapActions(['requestEncuestas'])
  }
}
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/home/modulo-encuestas.vue